import { createSelector } from 'reselect';

const selectRiskToleranceState = state => state.Profile.RiskTolerance;

export const selectDisclosures = createSelector(
  selectRiskToleranceState,
  ({ riskToleranceDisclosure }) => riskToleranceDisclosure,
);

export const selectRiskScore = createSelector(
  selectRiskToleranceState,
  ({ riskScore }) => riskScore,
);

const selectAllGroupIds = createSelector(
  selectRiskToleranceState,
  ({ groups: { allIds } }) => allIds,
);

export const selectSelectedGroupId = createSelector(
  selectRiskToleranceState,
  selectAllGroupIds,
  ({ selectedGroupId }, allGroupIds) => selectedGroupId || allGroupIds[0],
);

export const selectSelectedModelId = createSelector(
  selectRiskToleranceState,
  ({ selectedModelId }) => selectedModelId,
);

export const selectGroupsById = createSelector(
  selectRiskToleranceState,
  ({ groups: { byId } }) => byId,
);

export const selectModelsById = createSelector(
  selectRiskToleranceState,
  ({ models: { byId } }) => byId,
);

export const selectGroupOptions = createSelector(selectGroupsById, groupsById =>
  Object.values(groupsById),
);

export const selectRiskalyseProfile = createSelector(
  selectRiskToleranceState,
  ({ riskalyseProfile }) => riskalyseProfile,
);

export const selectShowRiskalysePopup = createSelector(
  selectRiskToleranceState,
  ({ showRiskalysePopup }) => showRiskalysePopup,
);

export interface Select3dRTQResult {
  riskScore: null | number;
  riskScoreDescription: string | null;
  capacity: null | { score: number; description: string };
  composure: null | { score: number; description: string };
  tolerance: null | { score: number; description: string };
}

export const select3dRTQResult = createSelector(
  selectRiskToleranceState,
  ({ riskScore, riskScoreDescription, capacity, composure, tolerance }): Select3dRTQResult => ({
    riskScoreDescription,
    riskScore,
    capacity,
    composure,
    tolerance,
  }),
);

enum RiskSource {
  Orion,
  Riskalyze,
}

export const selectIsRiskSourceOrion = createSelector(
  selectRiskToleranceState,
  ({ riskSource }: { riskSource: RiskSource }) => riskSource === RiskSource.Orion,
);
